export enum InputErrorStyle {
    default = 'default',
    highlighted = 'highlighted',
}
